import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../styles/component/home/carousel.css';

function Carousel() {
    const [images, setImages] = useState([]);
    const [currentImage, setCurrentImage] = useState(0);

    // Bilder laden
    useEffect(() => {
        const fetchAll = async () => {
            try {
                const res = await axios.get('https://nurleder.de/api/slider/');
                const allImages = res.data.flatMap(slider =>
                    slider.images.map(img => `${img.image}`)
                );
                setImages(allImages);
            } catch (err) {
                console.error("Fehler beim Laden der Bilder:", err);
            }
        };
        fetchAll();
    }, []);

    // Bilder vorladen (für Safari & mobile)
    useEffect(() => {
        images.forEach(src => {
            const img = new Image();
            img.src = src;
        });
    }, [images]);

    // Automatischer Bildwechsel
    useEffect(() => {
        if (images.length === 0) return;

        const interval = setInterval(() => {
            setCurrentImage(prev => (prev + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [images]);

    if (images.length === 0) return <p>Loading ...</p>;

    return (
        <div>
            <div className="carousel-row">

                <div className="text-block">
                    <h2>Handmade Lederkunst von Nurleder</h2>
                    <p>
                        In meiner Werkstatt entsteht keine Massenware – sondern Charakterstücke.
                        Jedes Produkt, das du hier findest, ist mit Sorgfalt, Leidenschaft und echtem Handwerk aus feinstem Leder gefertigt.
                        Ob Gürtel, Taschen, Accessoires oder kleine Alltagshelfer – jedes Stück erzählt eine Geschichte. Deine Geschichte.
                    </p>
                </div>

                <div className="carousel-wrapper">
                    <div className="carousel-container">
                        <img
                            key={currentImage}
                            src={images[currentImage]}
                            alt={`Slide ${currentImage}`}
                            className="carousel-image"
                        />
                    </div>

                    <div className="carousel-dots">
                        {images.map((_, index) => (
                            <span
                                key={index}
                                className={`dot ${index === currentImage ? 'active' : ''}`}
                                onClick={() => setCurrentImage(index)}
                            ></span>
                        ))}
                    </div>
                </div>

                <div className="text-block right">
                    <h2>Hast du Wunsch? Kein Problem!</h2>
                    <p>
                        Du hast besondere Vorstellungen oder einen Wunsch?
                        Kein Problem! Schreib mir einfach – ich fertige dein Produkt ganz nach deinen Ideen, ohne Einschränkungen.
                        Ob spezielle Maße, Farben oder Gravuren – du bestimmst, ich setze um.
                        ✋ Persönlich. Direkt. Unkompliziert.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Carousel;
